export const socialsData = {
    github: 'https://github.com/anasszerhoun',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/anas-zerhoun/',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@sreerag.rajan5',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}